import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed w-full h-full bg-[#3339] z-20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-10",
  src: _imports_0
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}